import React, { createContext, useState, useContext, ReactNode} from 'react';
import {id} from "date-fns/locale";

interface clipMamSelectedProps {
    clips: any[];
    addClips: (clips: any[]) => void;
    deleteSpecificClips : (idClip: string) => void;
    deleteAllClips : () => void;
    setClipState: (clips: any[]) => void;
    removeClips: (clipsToRemove: any[]) => void;
    isClipGroupInContext: (idClipGroup: string) => boolean;
    isClipInContext: (idClip: string) => boolean;
    aspectRatio: string;
    setAspectRatio: (aspectRatio: string) => void;
}

const ClipMamSelectedContext = createContext<clipMamSelectedProps| undefined>(undefined);

const ClipMamSelectedProvider: React.FC<{ children: ReactNode }> = ({ children }) =>  {

    const [clips, setClips] = useState<any[]>([]);
    const [aspectRatio, setAspectRatio] = useState<string>('16:9');

    function addClips(clips: any[]) {
        setClips((prev) => {
            const uniqueClips = new Map(prev.map((clip) => [clip.id, clip]));

            clips.forEach((clip) => {
                uniqueClips.set(clip.id, clip); // Aggiorna o aggiunge solo elementi unici
            });

            return Array.from(uniqueClips.values()); // Ritorna solo elementi unici
        });
    }

    function setClipState(clip: any[]) {
        setClips(clip);
    }

    function deleteSpecificClips (id: string) {
        setClips((prev) => prev.filter((clip) => clip.id !== id));
    }

    function deleteAllClips () {
        setClips([]);
    }

    function removeClips(clipsToRemove: any[]) {
        setClips((prev) => {
            const removeIds = new Set(clipsToRemove.map((clip) => clip.id));

            return prev.filter((clip) => !removeIds.has(clip.id));
        });
    }

    function isClipGroupInContext (idClipGroup : string): boolean {
       const clipInContext = clips.filter((clip) => clip.groupId === idClipGroup);

       if (clipInContext.length > 0)
           return true;
       else
           return false;
    }

    function isClipInContext (idClip : string): boolean {
        const clipInContext = clips.filter((clip) => clip.id === idClip);

        if (clipInContext.length > 0)
            return true;
        else
            return false;
    }

    return (
        <ClipMamSelectedContext.Provider value={{ clips, addClips, deleteSpecificClips, deleteAllClips, setClipState, removeClips, isClipGroupInContext, isClipInContext, setAspectRatio, aspectRatio }}>
            {children}
        </ClipMamSelectedContext.Provider>
);
}

// Custom hook to use the filter context
const useClipMamSelected = () => {
    const context = useContext(ClipMamSelectedContext);
    if (context === undefined) {
        throw new Error('useClipMamSelected must be used within a ClipMamSelected provider');
    }
    return context;
};

export { ClipMamSelectedProvider , useClipMamSelected };